import React, { useEffect, useState } from 'react';
import logo from '../../assets/blinkscribe 4.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import api from 'api/api';
import arrowleft from '../../assets/arrowleft.png'
import { useNavigate, useParams } from 'react-router-dom';
import ForceLogModal from './modal/forcelog';
import useModalStore from 'zustand/zustandstore';
const SubOptions = ({setScreen,data}) => {
  const{flow}=useParams()
  const navigate=useNavigate()
  const [role,setRole]=useState('')
      const { isOpen, openModal, closeModal,setModalValue } = useModalStore();
  // State to track the selected option
  const [selectedOption, setSelectedOption] = useState(0);
  const [loading,setLoading]=useState(false)
  const [error,setError]=useState('')
  const [id,setId]=useState('')
  const[ismodal,setIsModal]=useState(false)
  const[selectedplan,setSelectedPlan]=useState('')
const[dropdown,setDropDown]=useState('')

  // Handler to set selected option
  const handleOptionClick = (option) => {
    setSelectedOption(option);
  };
  const encodeData = (data) => {
    let encodedData = btoa(data);

    // Remove padding ('='), as Stripe does not support it
    encodedData = encodedData.replace(/=+$/, "");
    // Ensure it contains only alphanumeric, dashes, and underscores
    return encodedData.replace(/[^A-Za-z0-9_-]/g, "");
  };

  const handleSubmit=async()=>{
if(selectedOption=='1'){
    const clientReferenceId = encodeData(`${id}|${role}`);
        window.location.href =`https://buy.stripe.com/8wM6prcs38D35rO6oo?client_reference_id=${clientReferenceId}`;
  return
}



let payload={ "user_type": ''}
if(selectedOption==0){
  payload.user_type='BASIC'
}else if(selectedOption=='1'){
  payload.user_type='PLUS'
}else{
  payload.user_type='PRO'
  payload.ehr_name=dropdown
}

try {
  setLoading(true)
  
  const response= await api.put('/v1/users/user-cofig-data',payload)
        if(response.status===200){
          if(selectedOption==0){
           setSelectedPlan('Basic')
            setIsModal(true)
          // window.location.href = "https://buy.stripe.com/8wM6prcs38D35rO6oo";


          }else if(selectedOption=='1'){
            setModalValue({ screen :0}) 
            setModalValue({selectedRecord:{}})
             setSelectedPlan('Plus')
            //  window.location.href = "https://buy.stripe.com/8wM6prcs38D35rO6oo";
            // handleCheckout('blinkScribe Plus',5900)

          }else{
            setModalValue({ screen :0}) 
            setModalValue({selectedRecord:{}})
             setSelectedPlan('Pro')
            //  window.location.href = "https://buy.stripe.com/8wM6prcs38D35rO6oo";

            // handleCheckout('blinkScribe Pro',19990)
            setIsModal(true)
          }
        
        }else{
          setError('something went wrong')
        }
} catch (error) {
  setError('something went wrong')
}finally{
setLoading(false)
}


  }
  
  const fetchUser = async () => {
    try {
      const response = await api.get('/auth/me');  
      // Strict validation
      if (response?.config?.user_type ) {
        setRole(response.config.user_type);
        setId(response?.id)
      } else {
        setRole(''); // Assign empty string if validation fails
      }
    } catch (error) {
      console.error('Error fetching user:', error); // Log the error for debugging
      setRole(''); // Default to empty in case of error
    }
  };
  useEffect(()=>{
    fetchUser()
    },[])

  // Box shadow style for the selected option
  const selectedShadow = "shadow-[0px_0px_8px_8px_rgba(133,_182,_255,_0.35)]";

  return (
    <div className="w-full h-auto">
  {/* Overlay */}
  <div className="fixed inset-0 bg-black bg-opacity-50 z-10 min-h-screen h-auto min-w-full"></div>

  {/* Modal Container */}
  <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 
                  bg-white rounded-[12.781px] shadow-[0_0_8px_8px_rgba(0,0,0,0.04)] 
                  py-4 px-4 w-[90%] max-w-[95%] sm:w-[80%] md:w-[70%] max-h-[95vh] 
                  overflow-auto custom-scrollbar">
    
    {/* Cards Section */}
    <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 w-full justify-center items-center">
      {data
        .sort((a, b) => a.sort_order - b.sort_order)
        .map((plan, index) => {
          const isSelected = selectedOption === index;
          const isComingSoon = plan.coming_soon;
          const isDisabled = isComingSoon;
          const requiresEMR = plan.requires_emr_selection;
          const showActive =
            role?.toLowerCase() === plan.id.toLowerCase() ||
            (role?.toLowerCase() === 'basic' && plan.id.toLowerCase() === 'free');

          return (
            <div
              key={plan.id}
              onClick={() => !isDisabled && handleOptionClick(index)}
              className={`relative flex flex-col justify-between p-6 w-full sm:min-w-[240px] sm:max-w-[300px]
                          bg-white rounded-[12.781px] shadow-[0px_0px_12px_8px_rgba(0,0,0,0.10)] text-start
                          cursor-pointer transition-all duration-300 ease-in-out ${
                            isSelected ? 'h-[430px]' : 'h-[400px]'
                          } ${isSelected ? selectedShadow : ''} ${
                            isDisabled ? 'opacity-50 cursor-not-allowed' : ''
                          }`}
            >
              {isComingSoon && (
                <div className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold py-1 px-3 rounded-full">
                  Coming Soon
                </div>
              )}

              <div>
                <h3 className="text-sm sm:text-lg font-bold">{plan.title}</h3>
                {plan.subtitle && (
                  <h6 className="text-[9px] font-semibold">{plan.subtitle}</h6>
                )}
                <div className="flex items-center space-x-2 mt-1">
                  <h3 className="text-lg sm:text-[20px] font-bold">{plan.price_display}</h3>
                </div>

                <ul className="mt-4 text-xs sm:text-sm text-gray-600 space-y-2 pl-6">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <FontAwesomeIcon icon={faCheck} className="text-[#156CFE] mt-1" />
                      <span className="ml-2 text-[#000] font-semibold">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {showActive && (
                <div className="w-full mt-2 mb-2 flex items-center justify-center">
                  <div className="bg-[#B0CDFB] tracking-wide text-sm font-bold text-white px-6 py-1">
                    ACTIVE
                  </div>
                </div>
              )}

              {requiresEMR && (
                <select
                  className="block w-full border border-gray-300 rounded-md p-2 text-sm mt-2"
                  onChange={(e) => setDropDown(e.target.value)}
                  value={dropdown}
                  disabled={isDisabled}
                >
                  <option value="">Select EMR</option>
                  <option value="ATHENA">ATHENA</option>
                </select>
              )}
            </div>
          );
        })}

      {/* Submit Button */}
  
    </div>
    <div className='mt-4 flex justify-center'>


 <button
        onClick={() => handleSubmit()}
        disabled={
          loading ||
          (data[selectedOption]?.requires_emr_selection && !dropdown) ||
          data[selectedOption]?.coming_soon
        }
        className={`w-full sm:w-[60%] md:w-[35%] h-12 mt-4 flex items-center justify-center gap-2.5 
                    px-6 py-4 rounded-full border border-neutral-500 transition duration-300 ease-in-out 
                    ${
                      loading ||
                      (data[selectedOption]?.requires_emr_selection && !dropdown) ||
                      data[selectedOption]?.coming_soon
                        ? 'bg-gray-400 cursor-not-allowed text-white'
                        : 'bg-black text-white'
                    }`}
      >
        <div className="font-semibold text-sm">
          {loading ? 'Submitting...' : 'Continue'}
        </div>
      </button>

    </div>
       
  </div>

  {/* Force Log Modal */}
  <ForceLogModal isModalOpen={ismodal} selectedplan={selectedplan} />
</div>

  );
};

export default SubOptions;
